<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.3335 1.33325H2.66683C1.9335 1.33325 1.34016 1.93325 1.34016 2.66659L1.3335 14.6666L4.00016 11.9999H13.3335C14.0668 11.9999 14.6668 11.3999 14.6668 10.6666V2.66659C14.6668 1.93325 14.0668 1.33325 13.3335 1.33325ZM12.0002 9.33325H4.00016V7.99992H12.0002V9.33325ZM12.0002 7.33325H4.00016V5.99992H12.0002V7.33325ZM12.0002 5.33325H4.00016V3.99992H12.0002V5.33325Z"
            fill="#5625CC" />
    </svg>
</template>
<script>
export default {
    name: "MessagesUnreadBagde",
};
</script>
<style scoped>

</style>
